import { useEffect } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import { AnalyticsService } from './analyticsService';

const ROUTE_SCREEN_NAMES = {
  '/': 'Home',
  '/login': 'Login',
  '/signup': 'Signup',
  '/splash': 'Splash',
  '/explore': 'Explore',
  '/my-investments': 'Investments',
  '/mutual-funds': 'Mutual Funds',
  '/portfolio': 'Portfolio',
  '/portfolio/summary': 'Portfolio Summary',
  '/portfolio/mutual-fund': 'Portfolio Mutual Fund',
  '/portfolio/order': 'Portfolio Orders',
  '/portfolio/bond': 'Bond Details',
  '/redeem-funds': 'Redeem Funds',
  '/systematic-investment': 'Systematic Investment',
  '/systematic-investment/sip': 'SIP',
  '/systematic-investment/sip/active': 'Active SIPs',
  '/systematic-investment/sip/summary': 'SIP Summary',
  '/systematic-investment/sip/mandates': 'SIP Mandates',
  '/systematic-investment/stp': 'STP',
  '/systematic-investment/stp/active': 'Active STPs',
  '/systematic-investment/swp': 'SWP',
  '/systematic-investment/swp/active': 'Active SWPs',
  '/financial-overview': 'Financial Overview',
  '/financial-overview/portfolio': 'Investment Portfolio',
  '/financial-overview/bank-account': 'Bank Account',
  '/financial-overview/insurance': 'Insurance',
  '/notifications': 'Notifications',
  '/notifications/general': 'General Notifications',
  '/notifications/important': 'Important Notifications',
  '/profile': 'Profile',
  '/profile/personal-details': 'Personal Details',
  '/profile/nominee-details': 'Nominee Details',
  '/profile/bank-details': 'Bank Details',
  '/profile/add-bank-account': 'Add Bank Account',
  '/profile/add-nominee': 'Add Nominee',
  '/profile/mandates': 'Mandates',
  '/onboarding/status': 'Onboarding Status',
  '/onboarding/kyc': 'KYC',
  '/onboarding/kra-kyc': 'KRA KYC',
  '/onboarding/kyc-offline': 'KYC Offline',
  '/onboarding/fatca-details': 'FATCA Details',
  '/onboarding/nominee-details': 'Onboarding Nominee Details',
  '/onboarding/bank-linking': 'Bank Linking',
  '/risk-assessment': 'Risk Assessment',
  '/create-mandate': 'Create Mandate',
  '/pan-card': 'PAN Card',
  '/aadhar-card': 'Aadhar Card',
  '/document-upload': 'Document Upload',
  '/reports': 'Reports',
  '/help-center': 'Help Center',
  '/terms-and-conditions': 'Terms and Conditions',
  '/privacy-policy': 'Privacy Policy',
};

function getScreenName(pathname) {
  if (ROUTE_SCREEN_NAMES[pathname]) return ROUTE_SCREEN_NAMES[pathname];

  const segs = pathname.split('/').filter(Boolean);

  if (segs[0] === 'mutual-funds' && segs[1]) return 'Fund Details';
  if (segs[0] === 'explore' && segs[1] === 'nfo' && segs[2]) return 'NFO Details';
  if (segs[0] === 'explore' && segs[1] === 'nfo') return 'NFO';
  if (segs[0] === 'explore' && segs[1] === 'mf-collection-details') return 'Collection Details';
  if (segs[0] === 'portfolio' && segs[1] === 'mutual-fund' && segs[2]) {
    return segs[3] === 'redeem' ? 'Redeem Funds' : 'Portfolio Fund Details';
  }
  if (segs[0] === 'portfolio' && segs[1] === 'order' && segs[2]) return 'Order Details';
  if (segs[0] === 'systematic-investment' && segs[1] === 'sip' && segs[2] && !['active', 'summary', 'mandates'].includes(segs[2])) return 'SIP Details';
  if (segs[0] === 'systematic-investment' && segs[1] === 'stp' && segs[2] && segs[2] !== 'active') return 'STP Details';
  if (segs[0] === 'systematic-investment' && segs[1] === 'swp' && segs[2] && segs[2] !== 'active') return 'SWP Details';
  if (segs[0] === 'financial-overview' && segs[1] === 'portfolio') return 'Investment Portfolio Category';
  if (segs[0] === 'financial-overview' && segs[1] === 'bank-account' && segs[2]) return 'Bank Account Details';

  return segs.map((s) => s.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())).join(' > ') || 'Unknown';
}

export default function NavigationTracker() {
  const location = useLocation();

  useEffect(() => {
    const screenName = getScreenName(location.pathname);
    AnalyticsService.trackScreen(screenName, { page_path: location.pathname });
  }, [location.pathname]);

  return <Outlet />;
}
